import LinkIcon from '@/assets/icons/document/link-thin.svg?component';
import LinkCard from '@/modules/document/models/card/link-card.ts';
import { buildCardTitle, getVisibleEntityType } from '@/modules/common/models/card/card-display.util.ts';
import { TypeCode } from '@/modules/common/enums/type-code.ts';
import { markRaw } from 'vue';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import { DocumentStatusId } from '@/modules/common/enums/document-status-id.enum.ts';
import i18n from '@/i18n.ts';
import { LuxonUtil } from '@/modules/common/utils/luxon.util.ts';
import type { DocumentFullDto } from '@/modules/document/dto/document.dto.ts';
import type { TooltipLine } from '@/modules/common/types/ui.ts';

export default class DocumentCard extends LinkCard {
  readonly status: DocumentStatusId;
  readonly tooltipLines: TooltipLine[];

  constructor(response: DocumentFullDto) {
    super(
      response as unknown as Record<string, unknown>,
      'DOC_ID',
      'Содержание',
      markRaw(LinkIcon),
      'document',
      TableId.Documents
    );
    this.status = response['DS_ID'];

    const number = response['Номер'];
    const type = response['Тип'];
    const content = response['Содержание'];
    const visibleType = getVisibleEntityType(type, response['DT_ID'] === TypeCode.Document);
    const date = LuxonUtil.formatSQL(response['Дата'], i18n.global.locale.value) ?? '';

    this.title = buildCardTitle(number, visibleType);
    this.subtitle = content;

    this.tooltipLines = [
      visibleType && { label: 'document.shared.type', value: visibleType },
      { label: 'document.shared.content', value: content },
      { label: 'document.shared.creationDate', value: date },
    ].filter(Boolean) as TooltipLine[];
  }
}
